import React, { useCallback, useContext } from 'react'
import classnames from 'classnames'
import { Waypoint } from 'react-waypoint'
import { FormattedMessage } from 'react-intl'
//import { useLDClient } from 'launchdarkly-react-client-sdk'

import {
  NumbersLookRight,
  ChangeTheseValues,
} from 'src/constants/trackingEvents'

import { Button, Format, List, Text } from 'src/Components'
import { IconCheck, IconWrench } from 'src/Components/shared/Icon'
import AdditionalInfo from 'src/Components/shared/AdditionalInfo'
import { useEditLoanCtaHigherInDigestExp } from 'src/hooks/experimentation'

import styles from './PaidSoFar.module.scss'

const ScrollWaypointForExpand = ({ expand }) => (
  <Waypoint onEnter={expand} bottomOffset='300px'>
    <div />
  </Waypoint>
)

export const ConfirmLoanDetailsInfo = ({
  loans,
  expand,
  shouldCheckNumbers,
  expandCheckSection,
  markLoans,
  openLoans,
  disableScrollBehavior,
  useExperimentStyles,
}) => {
  const expanded = disableScrollBehavior || expandCheckSection

  const { trackScrolledIntoView, trackMouseOver, trackCtaClick } = useEditLoanCtaHigherInDigestExp()

  const handleUpdateLoanClick = useCallback(() => {
    trackCtaClick()
    openLoans()
  }, [openLoans])

  return (
    <>
      <Waypoint onEnter={trackScrolledIntoView} />

      {!disableScrollBehavior && <ScrollWaypointForExpand expand={expand} />}

      <AdditionalInfo
        visible={shouldCheckNumbers && expanded}
        cardWidth
        className={classnames(
          styles.additionalInfo,
          !expanded && styles.aiHide
        )}
        showDisclaimers={false}
        useExperimentStyles={useExperimentStyles}
        onMouseOver={trackMouseOver}
      >
        <Text
          element='h3'
          variant='neutralCool'
          variantCount='900'
          className={styles.foundLoans}
        >
          <FormattedMessage
            id='Homeowner.interest.doubleCheckNumbers'
            defaultMessage='Quick check, we found these loans for you from public loan records:'
          />
        </Text>

        <List.Bulleted className={styles.loanList}>
          {loans.map(loan => (
            <Text
              key={loan.id}
              className={styles.loanItem}
              size='s'
              variant='neutralCool'
              variantCount='900'
            >
              <FormattedMessage
                id='Homeowner.interest.doubleCheckLoanDescription'
                defaultMessage='{termYears} year loan at {rate} for {amount} from {date}'
                values={{
                  termYears: loan.termYears || loan.termYearsEstimated,
                  rate: (
                    <Text element='span' variant='success'>
                      {loan.rate || loan.rateEstimated}%
                    </Text>
                  ),
                  amount: (
                    <Text element='span' variant='success'>
                      <Format.Currency value={loan.amount} />
                    </Text>
                  ),
                  date: <Format.Date value={loan.date} format='MMMM YYYY' />,
                }}
              />
            </Text>
          ))}
        </List.Bulleted>

        <Button.Group className={styles.buttonGroup}>
          <Button
            onClick={markLoans}
            iconStart={IconCheck}
            track={NumbersLookRight}
            data-qa='confirm'
          >
            <FormattedMessage
              id='Homeowner.interest.confirm'
              defaultMessage='That looks right'
            />
          </Button>
          <Button
            onClick={handleUpdateLoanClick}
            iconStart={IconWrench}
            track={ChangeTheseValues}
            data-qa='change'
            className='exp-FromDigestButton_ToEditLoan'
          >
            <FormattedMessage
              id='Homeowner.interest.deny'
              defaultMessage='Change these numbers'
            />
          </Button>
        </Button.Group>
      </AdditionalInfo>
    </>
  )
}
